export type LearningActivityCategory = "学習" | "実践" | "宿題";
import { isDojoCourseSlug } from "@/lib/luagate/dojo-list";

export type LearningContentKind = "実践PJ" | "道場" | "授業動画" | "確認テスト";

export function resolveLearningActivityCategory(
  itemType: string,
  title = "",
): LearningActivityCategory {
  if (itemType === "homework") return "宿題";
  if (/実践\s*PJ|実践プロジェクト/i.test(title)) return "実践";
  if (itemType === "task") return "実践";
  return "学習";
}

export function resolveLearningContentKind(
  itemType: string,
  title = "",
  courseSlug?: string | null,
): LearningContentKind | null {
  if (/実践\s*PJ|実践プロジェクト/i.test(title)) return "実践PJ";
  // 道場は course (dojo-* のコース) か task (クラウドエディターの章) として学習パスに載る
  if (
    (itemType === "course" || itemType === "task") &&
    (isDojoCourseSlug(courseSlug) || title.includes("道場"))
  ) {
    return "道場";
  }
  if (itemType === "lecture") return "授業動画";
  if (itemType === "quiz") return "確認テスト";
  return null;
}

const CATEGORY_CLASSES: Record<LearningActivityCategory, string> = {
  学習: "bg-primary/20 text-primary-dark",
  実践: "bg-[#f5e7c5] text-[#7a5a12]",
  宿題: "bg-purple-100 text-purple-700",
};

export function LearningActivityTag({
  itemType,
  title,
}: {
  itemType: string;
  title?: string;
}) {
  const category = resolveLearningActivityCategory(itemType, title);

  return (
    <span
      data-learning-activity-category={category}
      className={`inline-flex shrink-0 items-center rounded px-2 py-1 font-noto max-sm:text-[0.9375rem] text-[10px] font-bold ${CATEGORY_CLASSES[category]}`}
    >
      {category}
    </span>
  );
}

const CONTENT_KIND_CLASSES: Record<LearningContentKind, string> = {
  実践PJ:
    "bg-gradient-to-r from-[#c83e00] to-[#a61b5b] text-white ring-2 ring-[#ffd2c2]",
  道場: "bg-accent/15 text-accent",
  授業動画: "bg-[#e8f0ff] text-[#2457b8]",
  確認テスト: "bg-purple-100 text-purple-700",
};

export function LearningContentKindTag({
  itemType,
  title,
  courseSlug,
}: {
  itemType: string;
  title?: string;
  courseSlug?: string | null;
}) {
  const kind = resolveLearningContentKind(itemType, title, courseSlug);
  if (!kind) return null;

  return (
    <span
      data-learning-content-kind={kind}
      className={`inline-flex shrink-0 items-center rounded px-2 py-1 font-noto max-sm:text-[0.9375rem] text-[10px] font-bold ${CONTENT_KIND_CLASSES[kind]}`}
    >
      {kind}
    </span>
  );
}
